module.exports = __webpack_public_path__ + "assets/img/25_435.3f9c4f1c.jpg";